const choiceInputTypes = {
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
};

export default choiceInputTypes;
